/* eslint-disable class-methods-use-this */ import { UIProfileController } from '../../../../../../shared/scripts/profile/UIProfileController.ts';
import { UIProfileRankedSeasonDropdownController } from '../../../../../../shared/scripts/profile/UIProfileRankedSeasonDropdownController.ts';
import { UIMProfileSettingsController } from './UIMProfileSettingController.ts';
import { CA } from '../../../../../../shared/scripts/analytics/Analytics.ts';
import { UIProfileFriendsController } from '../../../../../../shared/scripts/profile/UIProfileFriendsController.ts';
import { UIProfileRankedController } from '../../../../../../shared/scripts/profile/UIProfileRankedController.ts';
import { showPlayerFilterDialog } from '../../../../../../shared/scripts/ui_popup/showPlayerFilterDialog.ts';
import { setElementOnClick } from '../../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIViewProfilePopup } from '../../../../../../shared/scripts/profile/UIViewProfilePopup.ts';
import { HistoryTable } from '@colonist/clientforge';
import { mountUIReactComponent } from '../../../../../../shared/scripts/ui_platform/mountUIReactComponent.tsx';
import { navigateToReplay, toHistoryGameViews } from '../../../../../../shared/scripts/profile/historyUtils.ts';
import { UIUtilsEjsVariables } from '../../../../../../shared/scripts/UIUtilsEjsVariables.ts';
export class UIMProfileController extends UIProfileController {
    refreshProfileForUsernameChange(newUsername) {
        super.refreshProfileForUsernameChange(newUsername);
        this.rankedController.username = newUsername;
    }
    initControllers() {
        this.rankedController = new UIProfileRankedController(this.username);
        new UIProfileFriendsController(this.username, this.profileLinkController, undefined);
        this.settingsController = new UIMProfileSettingsController();
    }
    initSearchButton() {
        const overviewBtn = document.getElementById('m-profile-search-button-overview');
        const friendsBtn = document.getElementById('m-profile-search-button-friends');
        const bindSearchPopupToButton = (btn)=>{
            setElementOnClick(btn, ()=>{
                showPlayerFilterDialog({
                    onSearch: (searchValue)=>UIViewProfilePopup.init(searchValue)
                });
            });
        };
        bindSearchPopupToButton(overviewBtn);
        bindSearchPopupToButton(friendsBtn);
    }
    getUsername() {
        return this.username;
    }
    setStickyUsername(username) {
    // TODO: Implement functionality if we add the ability to see other peoples profile without UIMViewProfilePopup.ts
    }
    setUserIcon(iconImage) {
    // TODO: Implement functionality if we add the ability to see other peoples profile without UIMViewProfilePopup.ts
    }
    setMembershipIcon(membershipType) {
    // TODO: Implement functionality if we add the ability to see other peoples profile without UIMViewProfilePopup.ts
    }
    accountDoesNotExist() {
    // TODO: Implement functionality if we add the ability to see other peoples profile without UIMViewProfilePopup.ts
    }
    setHistory(historyData) {
        const { gameDatas, profileUserId } = historyData;
        const games = toHistoryGameViews(gameDatas, profileUserId, {
            isPopup: false
        });
        if (this.historyView == undefined) this.historyView = mountUIReactComponent('game-history-table', HistoryTable);
        this.historyView.render({
            games: games,
            profileUsername: decodeURIComponent(this.username),
            showReplayColumn: !UIUtilsEjsVariables.shouldHideStoreOnMobile,
            onReplayClick: navigateToReplay,
            onUsernameClick: (username)=>UIViewProfilePopup.init(username)
        });
    }
    setRankedSeasons(seasons) {
        new UIProfileRankedSeasonDropdownController(seasons, this.rankedController);
    }
    setProfileSettings(userLogins) {
        this.settingsController.setUserLoginState(userLogins);
    }
    constructor(username){
        super();
        this.username = username;
        this.profileLinkController.setUsername(this.username);
        this.initControllers();
        this.init();
        this.initSearchButton();
        const loginButtons = Array.from(document.getElementsByClassName('popup-login-btn'));
        // eslint-disable-next-line no-restricted-syntax
        loginButtons.forEach((loginButton)=>loginButton.addEventListener('click', ()=>CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.UserClickedLoginButton)));
    }
}
